// extracted by mini-css-extract-plugin
export default {"divTitle":"Header_divTitle__CnaFe","title":"Header_title__Md3AU","acronym":"Header_acronym__tSEbH","logo":"Header_logo__hLUwo"};